import { PRESALES_COUNTRIES } from "@func-core/core/domain/constants/countries";
import { ResultViewModel } from "@func-core/core/domain/view-models/result-view-model";

type QuotesPageViewModel = {
  isPreSalesCountry: boolean;
};

export const createQuotesPageViewModel = (
  data: ResultViewModel | null
): QuotesPageViewModel | null => {
  if (!data) return null;

  return {
    isPreSalesCountry: Object.keys(PRESALES_COUNTRIES).includes(data.country),
  };
};
